<template>
  <div>
    <div v-if="localShow" class="login-panel" :class="{'section-loading': login_loading}">
      <div class="row">
        <div class="col-12">
          <div id="cathay-logo">
            <img width="110"
            :src="`${BaseUrl}assets/common/cathay_logo.png`"
            :srcset="`${BaseUrl}assets/common/cathay_logo@2x.png`"/>
          </div>
        </div>
        <div class="col-6 d-none d-md-flex">
          <img width="243" class="login-img"
          :src="`${BaseUrl}assets/login/img_login.png`"
          :srcset="`${BaseUrl}assets/login/img_login@2x.png`">
        </div>
        <div class="col-12 col-md-6">
          <div class="title mobile">
            <h1 class="mb-0">登入</h1>
            <h4 class="mt-0">CRM 客戶關係管理</h4>
          </div>
          <h3 class="title desktop">登入 CRM 客戶關係管理</h3>
          <form class="form">
            <div class="form-group row">
              <label for="account" class="col-12 col-md-2 col-label-form">帳號</label>
              <div class="col-12 col-md-10">
                <input type="text"
                name="account"
                id="account"
                class="form-control"
                :class="{'is-invalid': errors.has('account')}"
                placeholder="請輸入帳號"
                v-model="form.account"
                v-validate="'required'" />
              </div>
            </div>
            <div class="form-group row">
              <label for="password" class="col-12 col-md-2 col-label-form">密碼</label>
              <div class="col-12 col-md-10">
                <input type="password"
                name="password"
                id="password"
                class="form-control"
                :class="{'is-invalid': errors.has('password')}"
                v-model="form.password"
                placeholder="請輸入密碼"
                v-validate="'required'"/>
              </div>
            </div>
            <div class="form-group">
              <div class="error-block" v-show="submitError">
                <span class="error">
                  您輸入的帳號或密碼有誤，或是無此帳號，請再次確認。
                </span>
              </div>
            </div>
            
            <div class="action pt-4">
              <button
              v-if="!login_loading"
              @click.prevent="doSubmit()"
              type="submit"
              class="btn btn-primary btn-block">
                登入
              </button>
              <button
              v-else
              type="submit"
              class="btn btn-primary btn-block"
              disabled>
                登入
              </button>
              <a href="#" class="link">忘記密碼 ❯</a>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div v-else class="fullPageBlank">

    </div>
    <form class="d-none" name="SAML" method="post" :action="SAMLForm.formAction">
      <input type="text" name="RelayState" v-model="SAMLForm.RelayState">
      <input type="text" name="SAMLRequest" v-model="SAMLForm.SAMLRequest">
      <input id="SAMLForm" type="submit" value="Submit">
    </form>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import { getUserSSO} from '../../service'
import axiosFormSubmit from '../../service/axiosFormSubmit.js'
import getCookie from '@/service/getCookie'
import deleteCookie from "@/service/deleteCookie";

export default {
  name: 'Login',
  data () {
    return {
      login_loading: false,
      submitError: false,
      webPath: '', // 紀錄當前網址
      form: {
        account: '',
        password: '',
        switch: 'I940040001',
      },
      samlStatus: '',
      SAMLForm:{
        formAction: '',
        RelayState: '',
        SAMLRequest: '',
      },
      localShow:false,  // SAML 開啟時 不要顯示 login 畫面
    }
  },
  computed: {
    ...mapGetters(['BaseUrl', 'SliceMode']),
    isFormValid() {
      if(!window.AJADev){
        return ( this.form.password.length > 0 ) && ( this.form.account.length > 0)
      }else{
        return true
      }
    }
  },
  methods: {
    ...mapActions(['updateUserToken', 'updateQueryKeyword', 'updateSamlStatus', 'updateUserRight']),
    checkSAML(){
      let url = '/servlet/HttpDispatcher/MXAuth/isLoggedIn'
      axiosFormSubmit(url,{},'引導登入頁').then(result => {
        this.login_loading = true
        if(result && result.returnMsg){
          const SAMLStatus = getCookie('saml-status')
          this.updateSamlStatus(SAMLStatus)
          if( SAMLStatus && SAMLStatus === 'on'){  // 如果 SAML 有開啟 formSubmit 出去導頁
            this.SAMLForm.formAction = result.detail.ssoUrl
            this.SAMLForm.RelayState = result.detail.RelayState
            this.SAMLForm.SAMLRequest = result.detail.SAMLRequest
            const submitForm = document.querySelector('#SAMLForm')
            setTimeout(() => {
              submitForm.click()
            }, 200);
            this.login_loading = false
          }else if( SAMLStatus && SAMLStatus === 'off'){ //  如果 SAML 關閉
            console.log('SAML 關閉');
            this.login_loading = false
            this.localShow = true
            this.$parent.appShow = true
          }else{  // 回傳的 detail 裡面沒有 ssoUrl & loginUrl 值
            console.log('API 錯誤');
            this.login_loading = false
            this.localShow = true
            this.$parent.appShow = true
          }
        }else{
          this.$toast.info({title: '登入錯誤'})
          this.login_loading = false
          this.localShow = true
          this.$parent.appShow = true
        }
      })
    },
    doSubmit () {
      // form submit 登入
      if(window.AJADev){ // for Offline mode
        this.OfflineMode()
        return false
      }

      this.login_loading = true
      this.$validator.validateAll().then(result => {  // 判斷帳號密碼是否有輸入
        if (!result) return false;

        this.officialSubmit()
      })
    },
    OfflineMode () { // for Offline mode
      getUserSSO().then(result => {
        if(result.body && result.body.userInfo){
          let user = result.body.userInfo
          user.workDate = result.body.workDate
          this.$store.dispatch({type: 'updateUserIP', data: result.body.ip})
          this.$store.dispatch({type: 'updateUserInfo', data: user})
          this.updateUserRight(user.apiKeyFunctionsPermission[user.apiKeys[0]])   // 寫入使用者權限
          this.updateUserToken(user.apiKeys[0])
          this.login_loading = false
          this.$router.push({path:'/'})
        } else {
          this.login_loading = false
          this.submitError = true
          console.log('登入失敗');
        }
      })
    },
    getUserInfo () { // 取得使用者資料
      getUserSSO().then(result => {
        if(result.body && result.body.userInfo){
          let user = result.body.userInfo
          user.workDate = result.body.workDate
          this.$store.dispatch({                               // 寫入 server 端回覆的 IP
            type: 'updateUserIP',
            data: result.body.ip
          })
          this.$store.dispatch({
            type: 'updateUserInfo',
            data: user
          })
          this.updateUserRight(user.apiKeyFunctionsPermission[user.apiKeys[0]])   // 寫入使用者權限
          this.updateUserToken(user.apiKeys[0])
          this.login_loading = false
          
          let redirectInfo = decodeURI(getCookie("redirect-info"));
          deleteCookie("redirect-info");

          if (redirectInfo) {
            redirectInfo = JSON.parse(redirectInfo);
          }
          if (redirectInfo && redirectInfo.url) {
            let root = location.protocol + "//" + location.host + "/crm/#";
            this.$router.push({ path: redirectInfo.url.replace(root, "") });
          } else {
            this.$router.push({ path: "/" });
          }
        } else {
          this.login_loading = false
          this.submitError = true
          console.log('登入失敗');
        }
      })
    },
    officialSubmit () { // 如果是平測與正式環境的登入
      let url = '/servlet/HttpDispatcher/MXAuth/login'
      const defaultUser = {
        userID: this.form.account.toUpperCase(),
        passWD: this.form.password,
      }

      axiosFormSubmit(url,defaultUser,'使用者登入').then(result => {
        let userToken = decodeURI(getCookie('api-keys'))
        if(userToken){
          this.getUserInfo() // 取得使用者資料
        }else{
          this.login_loading = false
          this.submitError = true
          console.log('未接收到 Token 或是 API key 格式不對');
        }
      }) 
    }
  },
  mounted() {
    // 紀錄當前網址
    this.webPath = window.location.href 
    
    this.updateQueryKeyword('')
    if(window.AJADev || getCookie('api-keys')){
      this.localShow = true
      this.$parent.appShow = true
      this.$router.push({path:'/'})
    }else{
      this.checkSAML()
    }
  },
}
</script>

<style lang="scss" scoped>

.fullPageBlank {
  height: 100vh;
  width: 100%;
  background: #F6FCF9;
}

</style>
